<template>
  <div>
    <v-select
      outlined
      required
      dense
      hide-details="auto"
      class="body2 mb-4"
      v-model="organization.industry"
      data-testid="createOrganization-input-industry"
      :label="`${$t('common.industry')}*`"
      :items="industries"
    />
    <v-select
      outlined
      required
      dense
      return-object
      hide-details="auto"
      class="body2 mb-4"
      item-value="code"
      item-text="name"
      v-model="organization.site.countryCode"
      data-testid="createOrganization-combobox-country"
      :items="countries"
      :label="`${$t('signup.country')}*`"
    />
    <v-checkbox
      class="ma-0 no-margin-label"
      hide-details="auto"
      v-model="account.receiveEmailReports"
      data-testid="createOrganization-checkbox-receiveEmailReports"
      :label="$t('auth.register.send_me_email_notifications')"
    />
    <Button
      block
      class="my-6"
      color="primary"
      data-testid="createOrganization-button-submit"
      :disabled="!requiredFieldsAreCompleted"
      :text="$t('signup.signup_for_free')"
      @click="onSubmit"
    />
    <v-alert
      v-if="showErrorAlert"
      colored-border
      color="red"
      dense
      border="left"
      elevation="2"
      class="text-caption mt-6"
    >
      <p class="pa-0 ma-0" v-html="$t('authManagePeople.sign_up_error')" />
    </v-alert>
    <p class="mt-4 body2 text-center blue-grey--text">
      {{ $t('signup.credit_card_is_not_required') }}
    </p>
  </div>
</template>

<script>
import constants from '@/constants'
import Button from '@/components/UI/Button'

export default {
  props: {
    account: {
      type: Object,
      required: true,
    },

    organization: {
      type: Object,
      required: true,
    },

    showErrorAlert: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    Button,
  },

  computed: {
    industries() {
      return constants.organization.industries
    },

    countries() {
      return constants.countries.map(country => {
        return {
          code: country.code,
          name: this.$t(`countries.${country.code}`),
        }
      })
    },

    requiredFieldsAreCompleted() {
      return this.organization.site.countryCode && this.organization.industry
    },
  },

  methods: {
    onSubmit() {
      this.$emit('createOrganizationSubmit', this.organization)
    },
  },
}
</script>

<style lang="scss">
.no-margin-label {
  label {
    margin-bottom: 0;
  }
}
</style>
